import Table, {
  ColumnConfig,
  Order,
} from "@app/components/table/table.component";
import TitleDescription from "@app/components/title-description";
import {
  DEBOUNCE_TIMER,
  DEFAULT_REQUEST_PARAMS,
  OrderType,
  RoutePath,
} from "@app/constants";
import UserService from "@app/services/http/user.service";
import { Meta, Activities } from "@app/types";
import { formatDateTime } from "@app/utils/util";
import { useDebouncedCallback } from "@core/hooks/use-debounced-callback.hook";
import { RequestParams } from "@core/services/http/http.type";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function CreatedDateColumnTable({ data }: { data: Activities }) {
  return (
    <div>
      <div>{formatDateTime(data.dateTime)}</div>
    </div>
  );
}

const columnConfig: ColumnConfig[] = [
  {
    label: "Thời gian",
    dataKey: "dateTime",
    width: "300px",
    component: CreatedDateColumnTable,
    hasOrder: true,
  },
  {
    label: "Nội dung",
    dataKey: "content",
    width: "400px",
    hasOrder: true,
  },
];

const HistoryTab = () => {
  const [activities, setActivities] = useState<Activities[]>([]);
  const { userId } = useParams();
  const navigate = useNavigate();
  const [requestParams, setRequestParams] = useState<RequestParams>(
    DEFAULT_REQUEST_PARAMS
  );

  const [meta, setMeta] = useState<Meta>();

  useEffect(() => {
    if (isNaN(Number(userId))) {
      return navigate(`/${RoutePath.USER_MANAGEMENT}`);
    }

    UserService.getUserActivities(Number(userId)).then((res) => {
      setActivities(res.data.items);
      setMeta(res.data.meta);
    });
  }, [userId]);

  const onSearchChange = useDebouncedCallback((value: string) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      keyword: value,
    };

    setRequestParams(newRequestParams);
  }, DEBOUNCE_TIMER);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = { ...requestParams, pageNum: page };

    setRequestParams(newRequestParams);
  };

  const onPageSizeChange = (pageSize: number) => {
    const newRequestParams: RequestParams = { ...requestParams, pageSize };

    setRequestParams(newRequestParams);
  };

  const onOrderChange = (data?: Order) => {
    if (data) {
      const newRequestParams: RequestParams = {
        ...requestParams,
        sortBy: data.orderBy,
        sortType: data.order as OrderType,
      };

      setRequestParams(newRequestParams);
    }
  };

  return (
    <div>
      <div className="rounded-xl bg-white px-5">
        <TitleDescription title="Hoạt động" onInputChange={onSearchChange} />
        <div className="mt-6">
          <Table
            columnConfig={columnConfig}
            dataTable={activities}
            meta={meta}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onRowClickOrder={onOrderChange}
            componentEmpty={
              <div className="text-center py-3 bg-[#f4f4f4]">
                <p className="text-[#666] text-xl">Không có dữ liệu</p>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default HistoryTab;
